import {useEffect} from 'react'

import {useEvents} from '@festi/common/contexts'

interface InitializeProps {
  index?: string
  queryID?: string
}

export const EventIndexQueryID = ({index, queryID}: InitializeProps) => {
  const {setCurrentIndex, setCurrentQueryID} = useEvents()

  useEffect(() => {
    queryID && setCurrentQueryID(queryID)
  }, [queryID, setCurrentQueryID])

  useEffect(() => {
    index && setCurrentIndex(index)
  }, [index, setCurrentIndex])

  return null
}
